import AllNameSelector from "./table-headers/AllNameSelector";
import DataFilterTableHeader from "./table-headers/DataFilterTableHeader";
import StatusFilterTableHeader from "./table-headers//StatusFilterTableHeader";
import TrashbinDataDeleteTableHeader from "./table-headers/TrashbinDataDeleteTableHeader";
import Grid from "@vapor/react-material/Grid";

const DocumentTableHeader = () => {
  return (
    <>
      <Grid container>
        <Grid alignItems="center" item sm={7} md={6}>
          <AllNameSelector />
        </Grid>
        <Grid alignItems="center" display="flex" item sm={3} md={4}>
          <TrashbinDataDeleteTableHeader />
          <DataFilterTableHeader name="Data caricamento" />
          <StatusFilterTableHeader name="Stato" />
        </Grid>
        <Grid item sm={2} md={2}></Grid>
      </Grid>
    </>
  );
};

export default DocumentTableHeader;
